var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MultiToggle-Wrapper"},_vm._l((_vm.ButtonList),function(ButtonList,index){return _c('a',{key:index,ref:"Buttons",refInFor:true,class:{
            'Active': _vm.IsSelected(ButtonList.Id),
            'disabled': _vm.disabled
        },attrs:{"href":"#","t_label":`EMPBE_Captions_${ButtonList.Id}`},on:{"click":function($event){return _vm.ToggleCaption(ButtonList.Id, index)}}},[_vm._v(" "+_vm._s(ButtonList.Text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }